import { defineComponent } from '@vue/composition-api';
// 激励
export default defineComponent({
  name: 'trinity-dialog',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showMask: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: 'OK'
    },
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  setup: function setup(props, ctx) {
    return {};
  }
});